import { SetUserAction, UpdateUserAction, USER_ACTION } from "./actions";
import { UserState } from "./types";

type UserActions = SetUserAction | UpdateUserAction;

export const userReducer = (
  state: UserState = {
    user: null,
  },
  action: UserActions,
): UserState => {
  switch (action.type) {
    case USER_ACTION.SET_USER_ACTION:
      return {
        ...state,
        user: action.user,
      };
    case USER_ACTION.UPDATE_USER_ACTION:
      return {
        ...state,
        user: action.updatedUser,
      };
    default:
      return state;
  }
};
